module.exports = __webpack_public_path__ + "img/xybank.1147dd4e.png";